import DispatchSpecialPriceServices from "@/services/DispatchSpecialPriceServices.js";

export default {
  getDispatchSpecialPrice: DispatchSpecialPriceServices.getList
}